// extracted by mini-css-extract-plugin
module.exports =  {"content":"e462cbfa4b--content--lJBIg","contacts":"e462cbfa4b--contacts--NzkGc"};